export const LOADER = 'loader';
export const LOADER_NO_NAME_BRANDS = 'loader-no-name-brands';

export const SKELETON = 'skeleton';
export const FAVOURITE_ACTIVE = 'favourites-active';
export const FAVOURITE_NOT_ACTIVE = 'favourites-not-active';

export const MODAL_OVERLAY = 'modal-overlay';
export const MODAL_CONTENT = 'modal-content';

export const GAME_CARD = 'game-card';
export const GAME_IMAGE = 'game-image';
export const GAME_LINK = 'game-link';
export const GAME_PLAY_BUTTON = 'game-play-button';

export const SLIDER_ARROW_PREVIOUS = 'slider-arrow-previous';
export const SLIDER_ARROW_NEXT = 'slider-arrow-next';

export const HEADING = 'heading';
export const HEADING_TITLE = 'heading-title';
export const HEADING_LINK = 'heading-link';

export const TAB_NAVIGATION = 'tab-navigation';
export const TAB_NAVIGATION_LINK = 'tab-navigation-link';

export const NAVIGATION = 'navigation';
export const NAVIGATION_LINK = 'navigation-link';
export const NAVIGATION_LINK_ICON = 'navigation-link-icon';

export const OFFER_ITEM = 'offer-item';
export const OFFER_ITEM_DESCRIPTION = 'offer-item-description';

export const OFFER_ITEM_IMAGE = 'offer-item-image';
export const OFFER_ITEM_TITLE = 'offer-item-title';
export const OFFER_ITEM_SUBTITLE = 'offer-item-subtitle';
export const OFFER_ITEM_CONTENT = 'offer-item-content';
export const OFFER_TERMS = 'offer-terms';
export const OFFER_TERMS_EXPAND_ICON = 'offer-terms-expand-icon';

export const TOP_SLIDER = 'top-slider';
export const TOP_SLIDER_ITEM = 'top-slider-item';
export const TOP_SLIDER_BUTTON = 'top-slider-button';
export const TOP_SLIDER_SLIDER_IMAGE = 'top-slider-image';

export const SEARCH_FORM = 'search-form';
export const SEARCH_FORM_INPUT = 'search-form-input';
export const SEARCH_FORM_ICON = 'search-form-icon';
export const SEARCH_FORM_BUTTON_CLEAR = 'search-form-button-clear';

export const GAME_HEADER_DESKTOP = 'game-header-desktop';
export const GAME_CLOSE_BUTTON = 'game-close-button';
export const GAME_FULLSCREEN_BUTTON = 'game-fullscreen-button';
export const GAME_TITLE = 'game-title';
export const GAME_PLAY_REAL_BUTTON = 'game-play-real-button';
export const GAME_FRAME = 'game-frame';

export const SEARCH_RESULT_GAMES_LIST = 'search-result-games-list';
export const GAMES_LIST = 'games-list';
export const RECENT_GAMES_LIST = 'recent-games-list';

export const PAGINATION = 'pagination';
export const PAGINATION_PREV_BUTTON = 'pagination-prev-button';
export const PAGINATION_NEXT_BUTTON = 'pagination-next-button';

export const BONUS_ITEM = 'bonus-item';
export const BONUS_ITEM_IMAGE = 'bonus-item-image';
export const BONUS_ITEM_TITLE = 'bonus-item-title';
export const BONUS_ITEM_SUBTITLE = 'bonus-item-subtitle';

export const BONUS_CARD = 'bonus-card';
export const BONUS_LINK = 'bonus-link';
export const BONUS_AMOUNT = 'bonus-amount';
export const BONUS_STATUS = 'bonus-status';
export const BONUS_PROGRESS_BAR = 'bonus-progress-bar';
export const BONUS_PROGRESS_STATUS = 'bonus-progress-status';
export const BONUS_PROGRESS_TIMER = 'bonus-progress-timer';
export const BONUS_EXPIRATION_DATE = 'bonus-expiration-date';
export const BONUS_WAGERING_AMOUNT = 'bonus-wagering-amount';
export const BONUS_STATUS_DESCRIPTION = 'bonus-status-description';
export const BONUS_NOT_AVAILABLE = 'bonus-not-available';

export const BONUS_IMAGE = 'bonus-image';
export const BONUS_GO_BACK_BUTTON = 'bonus-go-back-button';
export const BONUS_MOBILE_GO_BACK_BUTTON = 'bonus-mobile-go-back-button';
export const BONUS_CLOSE_BUTTON = 'bonus-close-button';
export const BONUS_TERMS = 'bonus-terms';
export const BONUS_TERMS_EXPAND_ICON = 'bonus-terms-expand-icon';
export const BONUS_TITLE = 'bonus-title';
export const BONUS_CONTENT_BLOCK = 'bonus-content-block';
export const BONUS_ITEM_SUCCESS_WAGERED_LABEL =
  'bonus-item-success-wagered-label';

export const BONUSES_CURRENT_LINK = 'bonuses-current-link';
export const BONUSES_HISTORY_LINK = 'bonuses-history-link';
export const BONUSES_HISTORY = 'bonuses-history';
export const BONUSES_HISTORY_LIST = 'bonuses-history-list';

export const BONUS_PARTICIPATE_BUTTON = 'bonus-participate-button';
export const BONUS_UNJOIN_BUTTON = 'bonus-unjoin-button';
export const BONUS_REJECT_BUTTON = 'bonus-reject-button';
export const BONUS_ALL_BONUSES_BUTTON = 'bonus-all-bonuses-button';
export const BONUS_DEPOSIT_BUTTON = 'bonus-deposit-button';

export const BONUS_TO_COLLECTING_GAMES = 'bonus-to-collecting-games';
export const BONUS_TO_WAGERING_GAMES = 'bonus-to-wagering-games';
export const BONUS_TO_TAKE_CASHBACK = 'bonus-to-take-cashback';

export const HALL_OF_FAME_NO_CONTENT = 'hall-of-fame-no-content';
export const HALL_OF_FAME_NO_CONTENT_IMAGE = 'hall-of-fame-no-content-image';
export const HALL_OF_FAME_NO_CONTENT_TITLE = 'hall-of-fame-no-content-content';
export const HALL_OF_FAME_NO_CONTENT_DESCRIPTION =
  'hall-of-fame-no-content-description';

export const HALL_OF_FAME_TABS = 'hall-of-fame-tabs';
export const HALL_OF_FAME_TAB_CURRENT = 'hall-of-fame-tab-current';
export const HALL_OF_FAME_TAB_HISTORY = 'hall-of-fame-tab-history';

export const HALL_OF_FAME_TOP_WINS_LIST = 'hall-of-fame-top-wins-list';
export const HALL_OF_FAME_TOP_WINS_ITEM = 'hall-of-fame-top-wins-item';
export const HALL_OF_FAME_TOP_WINS_LABEL = 'hall-of-fame-top-wins-label';

export const HALL_OF_FAME_WINS_LIST = 'hall-of-fame-wins-list';
export const HALL_OF_FAME_WINS_ITEM = 'hall-of-fame-wins-item';

export const HALL_OF_FAME_AMOUNT = 'hall-of-fame-amount';
export const HALL_OF_FAME_GAME_TEXT_LINK = 'hall-of-fame-game-text-link';
export const HALL_OF_FAME_GAME_IMAGE_LINK = 'hall-of-fame-game-img-link';
export const HALL_OF_FAME_PLAYER_ID = 'hall-of-fame-player-id';

export const HALL_OF_FAME_WELCOME_POPUP = 'hall-of-fame-welcome-popup';
export const HALL_OF_FAME_WELCOME_POPUP_IMAGE =
  'hall-of-fame-welcome-popup-image';
export const HALL_OF_FAME_WELCOME_POPUP_TITLE =
  'hall-of-fame-welcome-popup-title';
export const HALL_OF_FAME_WELCOME_POPUP_DESCRIPTION =
  'hall-of-fame-welcome-popup-description';
export const HALL_OF_FAME_WELCOME_POPUP_BUTTON =
  'hall-of-fame-welcome-popup-button';

export const HALL_OF_FAME_WIN_POPUP = 'hall-of-fame-win-popup';
export const HALL_OF_FAME_WIN_POPUP_IMAGE = 'hall-of-fame-win-popup-image';
export const HALL_OF_FAME_WIN_POPUP_TITLE = 'hall-of-fame-win-popup-title';
export const HALL_OF_FAME_WIN_POPUP_DESCRIPTION =
  'hall-of-fame-win-popup-description';
export const HALL_OF_FAME_WIN_POPUP_BUTTON = 'hall-of-fame-win-popup-button';

export const ACTIVE_BONUSES = 'active-bonuses';
export const ACTIVE_BONUSES_LIST = 'active-bonuses-list';
export const AVAILABLE_BONUSES = 'available-bonuses';
export const AVAILABLE_BONUSES_LIST = 'available-bonuses-list';

export const BONUS_WAGERING_FILTER_WIDGET = 'bonus-wagering-filter-widget';
export const BONUS_WAGERING_FILTER_WIDGET_TITLE =
  'bonus-wagering-filter-widget-title';
export const BONUS_WAGERING_FILTER_WIDGET_TOOLTIP =
  'bonus-wagering-filter-widget-tooltip';
export const BONUS_WAGERING_FILTER_WIDGET_TOOLTIP_CONTENT =
  'bonus-wagering-filter-widget-tooltip-content';
export const BONUS_WAGERING_FILTER_WIDGET_TOOLTIP_TITLE =
  'bonus-wagering-filter-widget-tooltip-title';
export const BONUS_WAGERING_FILTER_WIDGET_BUTTON =
  'bonus-wagering-filter-widget-button';
export const BONUS_GAMES_GRID = 'bonus-games-grid';

export const BONUS_BUTTON_ACTIVATE = 'bonus-button-activate';
export const BONUS_BUTTON_DEPOSIT = 'bonus-button-deposit';
export const BONUS_BUTTON_SUPPORT = 'bonus-button-support';
export const BONUS_BUTTON_UNJOIN = 'bonus-button-unjoin';
export const BONUS_BUTTON_REJECT = 'bonus-button-reject';
export const BONUS_BUTTON_TAKE_CASHBACK = 'bonus-button-take-cashback';
export const BONUS_LINK_GAMES = 'bonus-link-games';
export const BONUS_LINK_PLAY_GAME = 'bonus-link-play-game';
export const BONUS_LINK_AVAILABLE_BONUSES = 'bonus-link-available-bonuses';
export const BONUS_BUTTON_CLOSE = 'bonus-button-close';
export const BONUS_BUTTON_LOGIN = 'bonus-button-login';

export const NEW_BONUSES_PICTOGRAM = 'new-bonuses-pictogram';
export const HEADER_BONUSES_LINK = 'header-bonuses-link';

export const CANCEL_MODAL = 'cancel-modal';
export const CANCEL_BUTTON = 'cancel-button';
export const GO_BACK_BUTTON = 'go-back-button';

export const ERROR_TITLE = 'error-title';
export const GO_TO_MAIN_PAGE = 'go-to-main-button';

export const BUTTON_TO_TOP = 'button-to-top';

export const EMPTY_PAGE = 'empty-page';
export const EMPTY_PAGE_TITLE = 'empty-page-title';
export const EMPTY_PAGE_DESCRIPTION = 'empty-page-description';

export const PROVIDERS_SORTING_MODAL_TITLE = 'providers-sorting-modal-title';
export const PROVIDERS_SORTING_MODAL_CLOSE_BUTTON =
  'providers-sorting-modal-close-button';
export const PROVIDERS_SORTING_MODAL_OPTIONS_LIST =
  'providers-sorting-modal-options-list';
export const PROVIDERS_SORTING_MODAL_OPTION = 'providers-sorting-modal-option';
export const PROVIDERS_SORTING_MODAL_OPTIONS_APPLY_BUTTON =
  'providers-sorting-modal-apply-button';
export const PROVIDERS_SORTING_MODAL_OPTIONS_CANCEL_BUTTON =
  'providers-sorting-modal-cancel-button';
export const PROVIDERS_SORT_ORDER = 'providers-sort-order';

export const BIG_WIN_CONTAINER = 'big-win-container';
export const BIG_WIN_ITEM = 'big-win-item';

export const CURRENCY_CONFIRMATION_MOBILE_MODAL =
  'CURRENCY_CONFIRMATION_MOBILE_MODAL';
export const CURRENCY_CONFIRMATION_CONFIRM = 'CURRENCY_CONFIRMATION_CONFIRM';
export const CURRENCY_CONFIRMATION_DECLINE = 'CURRENCY_CONFIRMATION_DECLINE';
export const CURRENCY_CONFIRMATION_IMAGE = 'CURRENCY_CONFIRMATION_IMAGE';

export const RECENT_GAMES_MIGRATION_MODAL = 'RECENT_GAMES_MIGRATION_MODAL';
export const RECENT_GAMES_MIGRATION_CHECKBOX =
  'RECENT_GAMES_MIGRATION_CHECKBOX';
export const RECENT_GAMES_MIGRATION_BUTTON = 'RECENT_GAMES_MIGRATION_BUTTON';

export const RESPONSIBLE_GAMING_LIMITS_MODAL =
  'RESPONSIBLE_GAMING_LIMITS_MODAL';
export const RESPONSIBLE_GAMING_LIMITS_MODAL_CONFIRM =
  'RESPONSIBLE_GAMING_LIMITS_MODAL_CONFIRM';
export const RESPONSIBLE_GAMING_LIMITS_MODAL_DECLINE =
  'RESPONSIBLE_GAMING_LIMITS_MODAL_DECLINE';

export const GAME_OF_THE_DAYS_CARD = 'game-of-the-days-card';

export const PLAYER_LOCK_MODAL = 'PLAYER_LOCK_MODAL';
export const PLAYER_LOCK_MODAL_CLOSE_BUTTON = 'PLAYER_LOCK_MODAL_CLOSE_BUTTON';
export const PLAYER_LOCK_MODAL_ACCEPT_BUTTON =
  'PLAYER_LOCK_MODAL_ACCEPT_BUTTON';
